// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b146f73a","453":"5d5ec00d","455":"7a44424e","977":"0ffdaec7"}[chunkId] + ".chunk.js";
};